export default (state, _action) => state;
